const DATABASE_NAME = 'blueyard-training-media';
const STORE_NAME = 'files';
const DATABASE_VERSION = 1;

const openDatabase = () => new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') {
        reject(new Error('Offline media storage is not supported by this browser.'));
        return;
    }
    const request = indexedDB.open(DATABASE_NAME, DATABASE_VERSION);
    request.onupgradeneeded = () => {
        const database = request.result;
        if (!database.objectStoreNames.contains(STORE_NAME)) database.createObjectStore(STORE_NAME);
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error || new Error('Could not open media storage.'));
});

export const saveTrainingMedia = async (key, file) => {
    const database = await openDatabase();
    await new Promise((resolve, reject) => {
        const transaction = database.transaction(STORE_NAME, 'readwrite');
        transaction.objectStore(STORE_NAME).put(file, key);
        transaction.oncomplete = resolve;
        transaction.onerror = () => reject(transaction.error || new Error('Could not save the media file.'));
    });
    database.close();
    return key;
};

export const getTrainingMedia = async (key) => {
    if (!key) return null;
    const database = await openDatabase();
    const file = await new Promise((resolve, reject) => {
        const request = database.transaction(STORE_NAME, 'readonly').objectStore(STORE_NAME).get(key);
        request.onsuccess = () => resolve(request.result || null);
        request.onerror = () => reject(request.error || new Error('Could not read the media file.'));
    });
    database.close();
    return file;
};
